<template>
  <b-nav small tabs class="pageTabs" v-if="!presentationMode" style="position: relative">
    <b-nav-item :active="current=='list'" :to="'/u/' + pageUser.id + '?mode=list'"  v-b-tooltip.over title="사용자의 기기 목록을 표시합니다.">
      목록
    </b-nav-item>
    <b-nav-item :active="current=='map'" v-if="isLoginUserPageUserWritable && (countDevicesForMap > 0)"
      :to="'/u/' + pageUser.id + '?mode=map'" v-b-tooltip.over title="위치가 지정된 기기를 지도에서 확인합니다.">
      지도
    </b-nav-item>
    <!--b-nav-item :active="current=='graph'" v-if="isLoginUserPageUserWritable" :to="'/u/' + pageUser.id + '?mode=graph'" v-b-tooltip.over title="여러 기기의 데이터로 그래프를 그립니다..">
      그래프
    </b-nav-item-->
    <b-nav-item :active="current=='add'"  v-if="isLoginUserPageUserWritable" :to="'/u/' + pageUser.id + '?mode=add'"  v-b-tooltip.over title="새로운 기기를 등록합니다.">
      등록
    </b-nav-item>
    <div class="buttonBox mt-1">
      <slot></slot>
      <b-button v-if="!isLoginUserPageUser && !isIdLoginUserFriend(this.pageUser.id)" variant="secondary" size="sm" class="tabButton mr-2" @click="addFriend(pageUser)">
        친구 &plus;
      </b-button>
      <span v-else-if="!isLoginUserPageUser" class="m-1 mr-2 text-primary font-weight-bold tabText">
        <span v-if="isIdPageUserFriend(loginUser.id)">
          서로 친구
        </span>
        <span v-else>
          내 친구
        </span>
      </span>
      <span v-else class="m-1 mr-2 text-primary font-weight-bold tabText">
        나
      </span>
      <b-button v-if="!isLoginUserPageUser" @click="addBookmarkPageUser" variant="secondary" size="sm" class="tabButton" v-b-tooltip.hover.left title="북마크에 추가하기">
        북마크 &plus;
      </b-button>
    </div>
  </b-nav>
</template>
<script>
import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"
export default {
  name: "userTabs",
  mixins: [uiUtil, user],
  props: {
    pageDevice: Object,
    pageUser: Object,
    current: String,
  },
  mounted: function(){
  },
  methods: {
    addBookmarkPageUser: function() {
      this.addBookmark({
        "type": 10,
        "id": this.pageUser.id,
        "name": this.pageUser.displayName,
        "mode": this.current
      })
    }
  }
}
</script>
